import React from "react";
import { Button } from "@toddle-edu/ds-web";
import { AssessmentAddOutlined, NoteOutlined } from "@toddle-edu/ds-icons";
import PropTypes from "prop-types";
import classes from "./WorksheetBasicDetails.scss";

const WorksheetBasicDetails = ({
  hasSections,
  assessmentDetailsComponent,
  newWorksheetBasicDetailManager,
  worksheetBasicDetailInfo,
  isGeneratingAIQuestions,
  hasInstruction,
  setWorksheetBasicDetailsInfo,
  hasAssessmentTools,
  t,
}) => {
  return (
    <>
      <div className={classes.assessmentDetailCompContainer}>
        <div className={classes.assessmentDetailCompContentContainer}>
          {React.cloneElement(assessmentDetailsComponent, {
            newWorksheetBasicDetailManager,
            footerComponent: null,
            customClassForStep: classes.customClassForStep,
          })}
        </div>
      </div>
      {/*  WORKSHEET ASSESSMENT TOOLS > TOGGLE BUTTONS */}
      {!isGeneratingAIQuestions ? (
        <div className={classes.showAddDetailsButton}>
          {!hasInstruction && !worksheetBasicDetailInfo.showInstructions && (
            <Button
              size="large"
              type="outlined"
              dsVersion="2.0"
              variant="neutral"
              className={classes.instructionAndToolsButton}
              onClick={() =>
                setWorksheetBasicDetailsInfo({
                  ...worksheetBasicDetailInfo,
                  showInstructions: true,
                })
              }
              testId="worksheet-basic-details-assessment-tools-NoteOutlinedIcon"
              icon={<NoteOutlined />}
            >
              {t("common:add_with_label", {
                label: t("common:instruction"),
              })}
            </Button>
          )}
          {!hasAssessmentTools &&
            !worksheetBasicDetailInfo.showAssessmentTools && (
              <Button
                size="large"
                type="outlined"
                dsVersion="2.0"
                variant="neutral"
                className={classes.instructionAndToolsButton}
                onClick={() =>
                  setWorksheetBasicDetailsInfo({
                    ...worksheetBasicDetailInfo,
                    showAssessmentTools: true,
                  })
                }
                testId="worksheet-basic-details-assessment-tools-AssessmentAddOutlinedIcon"
                icon={<AssessmentAddOutlined />}
              >
                {t("common:add_with_label", {
                  label: t("worksheet:assessment_tool"),
                })}
              </Button>
            )}
        </div>
      ) : null}
      {hasSections ? <div className={classes.contentSeparator} /> : null}
    </>
  );
};

WorksheetBasicDetails.propTypes = {
  hasSections: PropTypes.bool.isRequired,
  assessmentDetailsComponent: PropTypes.element.isRequired,
  newWorksheetBasicDetailManager: PropTypes.object.isRequired,
  footerComponent: PropTypes.element.isRequired,
};

export default WorksheetBasicDetails;
